import React, { useEffect, useState } from "react";
import "./admin-dashboard.css";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { getUserNameFromStoreData } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../../core/store/app-store/app-store";
import http from "../../core/service/http";

export const useAdminDashboardHook = () => {
    const auth = useSelector((state) => state?.appStore?.auth);
  const profilePicture = auth.uploads.find(upload => upload.title === 'Profile Picture')?.data || 'https://static.vecteezy.com/system/resources/thumbnails/043/361/860/small_2x/hand-drawnman-avatar-profile-icon-for-social-networks-forums-and-dating-sites-user-avatar-profile-placeholder-anonymous-user-male-no-photo-web-template-default-user-picture-profile-male-symbol-free-vector.jpg';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  useEffect(() => {
    if (isMobile) {
      toggleSidebar();
    }
  }, [isMobile]);

  const getData = async () => {
    const response = await http.get("/v1/users/0");
    const data = JSON.parse(localStorage.getItem("data"));
    data.user[0] = response.data;
    data.uploads = response.data.uploads;
    localStorage.setItem("data", JSON.stringify(data));
    dispatch(setAuth(data));
  };
  const toggleSidebar = (isDefaultClose) => {
    const rootElement = document.querySelector("#root");
    if (isSidebarOpen) {
      rootElement.classList.remove("sidebar-open-root");
    } else {
      rootElement.classList.add("sidebar-open-root");
    }
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("data");
    dispatch(setAuth(null));
    navigate("/");
  };

  useEffect(() => {
    getData();
  }, []);
    return{
        auth,
        profilePicture,
        isSidebarOpen,
        toggleSidebar,
        handleLogout,
    };
}